class KartImageGallery {
  constructor() {
    this.initGallery();
  }

  initGallery() {
    // Find all gallery sections
    const sections = document.querySelectorAll('.kart-image-gallery');
    
    sections.forEach(section => {
      const showAllBtn = section.querySelector('.show-all-btn');
      const popup = section.querySelector('.gallery-popup');
      const closeBtn = section.querySelector('.back-btn');
      const galleryItems = section.querySelectorAll('.gallery-item');
      
      // Open popup when clicking "Show All Photos"
      if (showAllBtn) {
        showAllBtn.addEventListener('click', () => {
          this.openPopup(popup);
        });
      }
      
      // Open popup when clicking any gallery image
      galleryItems.forEach(item => {
        item.addEventListener('click', () => {
          this.openPopup(popup);
        });
      });
      
      // Close popup with back button
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          this.closePopup(popup);
        });
      }
      
      // Close popup with Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
          this.closePopup(popup);
        }
      });
      
      // Close popup when clicking overlay
      const overlay = popup.querySelector('.popup-overlay');
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.closePopup(popup);
        });
      }
    });
  }

  openPopup(popup) {
    popup.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  closePopup(popup) {
    popup.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new KartImageGallery();
});